// SPDX-License-Identifier: LicenseRef-VicZhuProprietary
// SPDX-FileCopyrightText: 2026 Vic Zhu <viczhu2014@gmail.com>

import type { User } from '../types'

export type OwnerStatus = 'active' | 'pending' | 'disabled'

/**
 * Derive the display status of a pet-owner account from `accountStatus`.
 *
 * IMPORTANT: status comes from `accountStatus`, NOT email verification.
 * Vet-registered owners are created `_verified: true` with a claim email, so
 * `_verified` does not distinguish pending from confirmed — `accountStatus`
 * does. Legacy owners predating the field (null) are treated as active, since
 * they are established accounts and must not be mislabeled "Pending".
 */
export function getOwnerStatus(owner: Pick<User, 'accountStatus'>): OwnerStatus {
  switch (owner.accountStatus) {
    case 'invited':
    case 'pending_trial_verification':
      return 'pending'
    case 'disabled':
      return 'disabled'
    default:
      return 'active'
  }
}
